module.exports = {
  // 请求后台API地址
  // baseUrl: '/test-api'
  baseUrl: 'api'
}
